import React from 'react';

interface LogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  dark?: boolean;
  className?: string;
}

const sizes = {
  sm: { icon: 32, text: 'text-lg' },
  md: { icon: 40, text: 'text-xl' },
  lg: { icon: 48, text: 'text-2xl' },
};

const Logo: React.FC<LogoProps> = ({ variant = 'full', size = 'md', dark = false, className = '' }) => {
  const s = sizes[size];

  const icon = (
    <svg
      width={s.icon}
      height={s.icon}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#14b8a6" />
        </linearGradient>
      </defs>
      {/* Rounded square tilted ~8° */}
      <g transform="rotate(-8 24 24)">
        <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#logoGrad)" />
      </g>
      {/* Lightning-bolt-checkmark */}
      <path
        d="M26 12L18 26h6l-2 10 10-14h-6l2-10z"
        fill="white"
        fillOpacity="0.95"
      />
    </svg>
  );

  if (variant === 'icon') {
    return <span className={className}>{icon}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {icon}
      <span className={`font-heading ${s.text} tracking-tight`}>
        <span className={`font-semibold ${dark ? 'text-white' : 'text-gray-800'}`}>Instant</span>
        <span className={`font-extrabold ${dark ? 'text-primary-200' : 'text-primary'}`}>Exam</span>
      </span>
    </span>
  );
};

export default Logo;
